import { t } from "ttag";

import { DashboardBrandingProvider } from "agavepulse/branding/DashboardBrandingProvider";
import type { DashboardBranding } from "agavepulse/theme/branding-types";
import { Box, Text } from "metabase/ui";

/**
 * A miniature of the chrome a client sees, rendered through the same
 * `DashboardBrandingProvider` the real dashboard uses.
 *
 * Reusing the provider rather than hand-styling swatches means the preview cannot drift
 * from what actually ships: if the derivation changes, this changes with it.
 */
export function BrandingPreview({
  branding,
}: {
  branding?: DashboardBranding | null;
}) {
  return (
    <Box>
      <Text fw="bold" size="sm" mb="xs">
        {t`Preview`}
      </Text>
      <DashboardBrandingProvider branding={branding}>
        <Box
          p="md"
          style={{
            border: "1px solid var(--mb-color-border)",
            borderRadius: "0.5rem",
            background: "var(--mb-color-background)",
          }}
          data-testid="agavepulse-branding-preview"
        >
          {branding?.logoUrl ? (
            <img
              src={branding.logoUrl}
              alt=""
              height={24}
              style={{
                height: 24,
                objectFit: "contain",
                marginBottom: "0.5rem",
              }}
            />
          ) : null}
          <Box
            px="sm"
            py="xs"
            mb="sm"
            style={{
              display: "inline-block",
              borderRadius: "0.25rem",
              background: "var(--mb-color-brand)",
              color: "var(--mb-color-text-white)",
              fontSize: "0.75rem",
            }}
          >
            {t`Primary button`}
          </Box>
          <Text size="xs" style={{ color: "var(--mb-color-brand)" }}>
            {t`A link in the client's brand color`}
          </Text>
        </Box>
      </DashboardBrandingProvider>
    </Box>
  );
}
